import { type ReactNode } from 'react';
import './main-content.css';

/**
 * Props for MainContent component
 */
interface MainContentProps {
  /** Child content to render */
  children: ReactNode;
  /** Whether to apply the dock notch clipping (default: true) */
  hasNotch?: boolean;
}

/**
 * MainContent wrapper component
 * Provides the main content area with optional notch clipping around the dock
 *
 * The notch creates a rounded cutout at the bottom center that "hugs" the dock,
 * making the content appear to grow around the dock rather than going under it.
 */
export function MainContent({
  children,
  hasNotch = true,
}: MainContentProps): JSX.Element {
  return (
    <main
      className={`main-content ${hasNotch ? 'main-content--with-notch' : ''}`}
    >
      <div className="main-content-inner">{children}</div>
    </main>
  );
}

export default MainContent;
